import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RookeryRegularFont } from 'v3/styles/common';

export const TitleSmallStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 0.75rem ${RookeryRegularFont}`,
}));

export const TitleSmallBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `700 0.75rem ${RookeryRegularFont}`,
}));
